import { useQuery } from '@tanstack/react-query';
import { fetchIncomingTransactionById } from '@/api/transactions';
import type { IncomingTransactionDetail } from '@/api/transactions/types';

export const incomingTransactionDetailKeys = {
  detail: (txId: string) => ['incoming-transaction-detail', txId] as const,
};

function normalizeDetail(raw: unknown): IncomingTransactionDetail | null {
  if (!raw || typeof raw !== 'object') return null;
  const obj = raw as Record<string, unknown>;
  const d = (obj.data ?? obj) as Record<string, unknown>;
  if (!d?.id) return null;
  return d as unknown as IncomingTransactionDetail;
}

export function useIncomingTransactionDetail(txId: string) {
  return useQuery({
    queryKey: incomingTransactionDetailKeys.detail(txId),
    queryFn: async () => {
      const res = await fetchIncomingTransactionById(txId);
      return normalizeDetail(res);
    },
    enabled: !!txId,
  });
}
